import { useEffect, useState } from "react";
import general from "../../../general";
import { useReactive, useScroll } from "ahooks";
import moment from "moment";
import { Link } from "react-router-dom";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import '../../../css/gameTrade.css';
import GfyxItem from "../../components/GfyxItem";
import { Popover } from 'antd-mobile'

const actions = [
  { index: 0, text: '全部交易', trade_featured : 2, sort_type:''},
  { index: 1, text: '官方严选', trade_featured : 0, sort_type:''},
  { index: 2, text: '自由交易',trade_featured : 1, sort_type:'' },
  { index: 3, text: '价格升序', trade_featured : 2, sort_type:'asc' },
  { index: 4, text: '价格降序' , trade_featured : 2, sort_type:'desc'},
]

export default props => {
  const data = useReactive({
    active: props.active,
  });
  useEffect(() => {
    data.active = props.active;
  }, [props]);
  const [trades, setTrades] = useState([]);
  const [more, setMore] = useState();
  const [index, setIndex] = useState(0)
  useEffect(() => {
    load({})
    props.setOperate((
      <Popover>
        <Popover.Menu
          getContainer={()=>document.getElementsByClassName('game-trade')[0]}
          style={{ '--arrow-size': '0',border:'1px solid #ddd',borderRadius:'6px'}}
          actions={actions}
          destroyOnHide={true}
          onVisibleChange={visible=>{
            if (visible) {
              const div = document.getElementsByClassName('adm-popover-menu-list-inner')[0]
              const children = div.children;
              for (let i = 0; i < children.length; i++) {
                div.children[i].classList.remove('active')
              }
              div.children[index].classList.add('active');
            }
          }}
          onAction={node => {
            setIndex(node.index)
          }}
          trigger='click'
          placement='bottom'
        >
          <div style={{display:'flex',alignItems:'center'}}>
            <div style={{paddingRight:'5px'}}>{actions[index].text}</div>
            <img src="resources/250410/down.png" alt="" width={8}/>
          </div>
      </Popover.Menu>
      </Popover>
    ))
  }, [index]);
 
  const load = (parms = {}) => {
    if (data.loading) {
      return;
    }
    data.loading = true;
    Dialog.loading();
    general.axios.post('/user/tradeV2/getTradeList', {
      member_id: undefined,
      username: undefined,
      trade_type: '3',
      sort_type: actions[index].sort_type,
      trade_featured: actions[index].trade_featured,
      game_id: props.query.id,
      pagination: { count: 100, page: 1 }
    })
      .finally(() => {
        data.loading = false;
        Dialog.close();
      })
      .then(res => {
        if (!data.init){
          setTimeout(() => {
            window.scrollTo({top: 0,});
          }, 100);
        }
        data.init = true;
        let result = res.data.data;
        setTrades(result.account_list);
        setMore(result.paginated.more);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }

  return (
    <div className="game-trade" style={{paddingTop:'10px'}}>
      {/* <img className='top-icon' src="/resources/game/trade-banner.png" alt="" /> */}

      {trades.map(trade =>
        <div key={trade.trade_id}>
          <GfyxItem>{trade}</GfyxItem>
        </div>
        )}
      {trades.length == 0 && data.init ? <div className="recovery-empty"><img src="/resources/game/detail-trade-place.png" alt="" />暂无交易</div> : null}
      {trades.length > 0 && data.init && more == 0 ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    </div>
  );
};